<!-- @if(userData.authProviderId == 2 || userData.authProviderId == 3 || userData.authProviderId == 5 || userData.authProviderId == 7){ -->
    <!-- <div class="user-communication user-communication-social">
        <div class="user-message">
            <h3>Social login ends soon</h3>
            <p>Apple, Google and Facebook logins won't be supported after December 28th, 2024.</p>
        </div>
        <div class="user-action-btn">
            <button (click)="goToExport();">Download your data</button>
        </div>
    </div> -->
<!-- }@else if(userData.authProviderId == 4 || userData.authProviderId == 26){ -->
    <!-- <div class="user-communication user-communication-storage">
        <div class="user-message">
            <h3>Hooray! You are upgraded 🎉</h3>
            <p>Download <strong>JioAICloud mobile app</strong> to unlock advanced AI features and claim free storage!</p>
            @if(universalService.isMobileDevice){
                <button (click)="goToDownloadApp();">Download mobile app</button>
            }
        </div>
        @if(!universalService.isMobileDevice){
            <div class="user-action-btn">
                <button (click)="goToDownloadApp();">Download mobile app</button>
            </div>
        }
    </div> -->
<!-- } -->
@if( userData != undefined && userData.isNewUserNotify != undefined && userData.isNewUserNotify == "Y" && universalService.isMobileDevice){
    <div class="user-communication user-communication-storage">
        <div class="user-message">
            <h3>Upgrade your cloud experience!</h3>
            <p>Download <strong>JioAICloud mobile app</strong> to unlock advanced AI tools and exclusive features.</p>
            @if(universalService.isMobileDevice){
                <button (click)="goToDownloadApp();">Download now</button>
            }
        </div>
        @if(!universalService.isMobileDevice){
            <div class="user-action-btn">
                <button (click)="goToDownloadApp();">Download now</button>
            </div>
        }
    </div>
}
